<template>
  <div>
    <el-dialog :title="formData.id ? '编辑城市' : '添加城市'" :visible.sync="modals" width="600px" :before-close="reset">
      <el-form ref="formData" :model="formData" label-width="100px">
        <el-form-item label="用户昵称：">
          {{info.nickname}}
        </el-form-item>
        <el-form-item label="评价内容：">
          {{info.content}}
        </el-form-item>
        <el-form-item label="评价图片：">
          <div v-viewer>
            <img v-for="src in info.imagesArray" :src="src" :key="src"/>
          </div>
        </el-form-item>
        <el-form-item label="评价回复：">
          <el-input type="textarea" v-model="formData.reply" placeholder="请输入评价回复"></el-input>
        </el-form-item>
        <el-form-item label="审核状态：">
          <el-radio-group v-model="formData.status">
            <el-radio :label="10">通过</el-radio>
            <el-radio :label="20">拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reset">取 消</el-button>
        <el-button type="primary" @click="submit" :loading="is_submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  orderCommentInfoApi,
  orderCommentVerifyApi
} from '@/api/order';

export default {
  data(){
    return {
      modals: false,
      formData: {
        id:0,
        status: 10,
        reply: '',
      },
      info:{},
      is_submit: false,
    };
  },
  methods: {
    // 初始数据
    initData(id){
      if (id){
        orderCommentInfoApi({id:id}).then(data=>{
          if (!data){
            this.$message.error('信息不存在');
            return false;
          }
          this.info = data;
          this.formData.id = data.id;
          this.modals = true;
        }).catch(res=>{
          this.$message.error(res.msg);
        });
      }
    },
    // 提交
    submit(){
      if(this.is_submit){
        return this.$message.warning('请勿重复提交');
      }
      this.is_submit = true;
      orderCommentVerifyApi(this.formData).then((res)=>{
        this.is_submit = false;
        this.$message.success('提交成功');
        this.reset();
        this.$emit('submitOk');
      }).catch((err)=>{
        this.is_submit = false;
        this.$message.error(err.msg);
      });
    },
    // 关闭
    reset(){
      this.formData = {
        status: 10,
        reply: '',
      };
      this.modals = false;
    },
  }
}
</script>

<style>
/* .el-select .el-input__inner {
  border: none;
}
.border-left {
  border-left: 1px solid #DCDFE6;
} */
</style>
